// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3y3Fv","select":"Header_select__LdcqD","clinic":"Header_clinic__2lmL3"};